module.exports = __webpack_public_path__ + "static/media/dls.b61e1cba.jpg";